module.exports = __webpack_public_path__ + "static/img/EC@3x.55197f84.jpg";